import {
  MAKER_TAB_TITLE,
  type CatalogSearchTabTitle,
} from '@/constant/brandCarParams'

/**
 * カタログ検索(swiper-slide)の表示状態を保持するストア
 * ページ遷移をまたいでスライドの選択状態を復元するために使う。
 *
 * 永続化はしない。要件である「他画面から戻ったときにタブを保持」の対象経路
 * (最新自動車カタログ・お好み検索・ボディタイプ選択・車種一覧)はいずれも
 * SPA 内の遷移なので、store の保持だけで復元できるため。
 * ピックアップ記事のように window.location でフルロード遷移する経路では
 * 復元されないが、これは useState だった従来と同じ挙動。
 * sessionStorage へ永続化するとアプリ内に初期化契機が無くなり、
 * フルロードや WebView の開き直し後もタブが残る仕様変更になるため採用しない。
 */
export const useCatalogSearchStore = defineStore('catalog-search', () => {
  /** 表示中のタブ名(初期表示はメーカータブ) */
  const selectedTabTitle = ref<CatalogSearchTabTitle>(MAKER_TAB_TITLE)

  /** ボディタイプサブモーダルに表示する項目の位置(未選択時は -1) */
  const displayIndex = ref<number>(-1)

  const setSelectedTabTitle = (tabTitle: CatalogSearchTabTitle): void => {
    selectedTabTitle.value = tabTitle
  }

  const setDisplayIndex = (index: number): void => {
    displayIndex.value = index
  }

  return {
    selectedTabTitle,
    displayIndex,
    setSelectedTabTitle,
    setDisplayIndex,
  }
})
